const URLS = {
  BASE: '/',
  BUDGET: '/budget',
  NEEDCAR: '/needcar',
  PHONE: '/phone',
  NAME: '/name',
  BIRTHDAY: '/birthday',
  GENDER: '/gender',
  WORKING: '/working',
  DOWNPAYMENTS: '/downpayments',
  MOUNTHLY: '/mounthly',
  CONFIRMATION: '/confirmation',
  EXPERIENCE: '/experience',
  UPLOAD: '/upload',
  SEARCH: '/search',
  APPROVED: '/approved',
  CAR: '/car/:id',
  PAYMENT: '/payment',
  RETURNED: '/returned',
  SIGNATURE: '/signature',
  PROFILE: '/profile',
  PROFILECARS: '/profilecars',
  DELIVERY: '/delivery',
  RESPASS: '/respassword',
  LOGINADMIN: '/loginadmin',
  CAREDITOR: '/careditor',
  LOGIN: '/login'
};

const apiUrl = '/api/';

const API = {
  SIGN_UP: `${apiUrl}sign-up`,
  SIGN_UP_CODE_ACTIVATION: `${apiUrl}sign-up-check-activation-code`,
  SIGN_IN: `${apiUrl}sign-in`,
  SIGN_IN_CODE_ACTIVATION: `${apiUrl}sign-in-check-activation-code`,
  BIRTHDAY_ADD: `${apiUrl}add-birth-day-to-user-model`,
  GENDER: `${apiUrl}male-or-female`,
  WORKING: `${apiUrl}get-working-status`,
  DOWNPAYMENTS: `${apiUrl}get-minimum-down-payment-for-unemployment`,
  EXPERIENCE: `${apiUrl}work-experience`,
  MOUNTHLY: `${apiUrl}monthly-income`,
  CONFIRMATION: `${apiUrl}confirm-monthly-income`,
  NAME: `${apiUrl}get-user-name`,
  FACEBOOK: `${apiUrl}auth/facebook`,
  FACEBOOK_PROCCESS: `${apiUrl}auth/facebook-proccess`,
  FILE_UPLOAD: `${apiUrl}files_restore`,
  FILE_LIST: `${apiUrl}files_restore/list`,
  SEARCH: `${apiUrl}search-cars`,
  APPROVED: `${apiUrl}approved-cars`,
  SELECAR_CAR: `${apiUrl}select_car`,
  SELECTED_CARS: `${apiUrl}select_car/list`,
  DELIVERY_GET: `${apiUrl}get-delivery-information`,
  DELIVERY_SET: `${apiUrl}accept-delivery`,
  SIGNATURE: `${apiUrl}get-data-for-signature`,
  SIGNATURE_SEND: `${apiUrl}signature-accept`,
  PAYMENT_PAYPAL: `${apiUrl}generate-client-token-for-paypal`,
  PAYMANT_SEND: `${apiUrl}get-payment-method-nonce-from-client-side-creating-transaction`,
  EMAIL: `${apiUrl}add-email`,
  UPLOAD_NOTIFICATION: `${apiUrl}upload-notifications`,
  USER_PROGRESS: `${apiUrl}user-progress`,
  USER_CAHGE_STEP: `${apiUrl}user-change-steps`,
  USER_ROMVE: `${apiUrl}user-delete`,
  LOGIN_ADMIN: `${apiUrl}admin/login`,
  ADD_ADMIN_USER_REQ: `${apiUrl}admin/registr`,
  LOGOUT_ADMIN: `${apiUrl}admin/logout`,
  RESET_PASS_ADMIN: `${apiUrl}admin/password/forgot`,
  SEND_NEW_PASS_ADMIN: `${apiUrl}admin/password/change`,
  CHECK_AUTHORIZATION: `${apiUrl}admin/dashboard`,
  GET_CARS_LIST_EDITOR: `${apiUrl}admin/cars-list`,
  UPLOAD_IMG_CAR: `${apiUrl}admin/file/upload`,
  ADD_NEW_CAR: `${apiUrl}admin/cars/add`,
  DELETE_CAR: `${apiUrl}admin/car`,
  EDIT_CAR: `${apiUrl}admin/cars/edit`
};

const IGNORE_ERROR_NOTIFY_URL = {
  UPLOAD_PAGE: '/api/files_restore'
};

const TELEPHONE_CODE = process.env.NODE_ENV === 'development' ? '+38' : '+1';
const GA_KEY = 'UA-120730529-1';
export { URLS, API, TELEPHONE_CODE, GA_KEY, IGNORE_ERROR_NOTIFY_URL };



// WEBPACK FOOTER //
// ./src/config.js